import { DataProvider, GlobalActionsProvider } from '@plasmicapp/host';
import { useActivityFeedStore } from 'hooks/stores/useActivityFeedStore';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

const ACTIVITY_FEED_ALLOWED_PATHS = ['/dashboard']

export const ActivityFeedGlobalContext = observer(
  ({ children }: React.PropsWithChildren) => {
    const router = useRouter()

    const { displayedItems: activityFeedItems, startFetching, stopFetching } = useActivityFeedStore();


    useEffect(() => {
      (async() => {
        if (!ACTIVITY_FEED_ALLOWED_PATHS.includes(router.asPath)) {
          stopFetching();
        }else{
          await startFetching()
        }
      })()
    }, [router.asPath]);

    return (
      <GlobalActionsProvider
        contextName="ActivityFeedGlobalContext"
        actions={{}}
      >
        <DataProvider
          name="activity_feed"
          data={{
            activityFeedItems,
          }}
        >
          {children}
        </DataProvider>
      </GlobalActionsProvider>
    );
  }
);
